import { GUID } from "../../../helpers/guid.helper";

export class TutorDto {
    Id: string;
    RelationshipId: number;
    FirstName: string;
    LastName: string;
    DocumentNumber: string;
    CUIL: string;
    Email: string;
    HighestEducationLevel: string;
    PhoneNumber: string;
    MobilePhoneNumber: string;
    AnotherContactPhone: string;
    Birthdate: string;
    Photo: string;
    IdentificationTypeId: number;
    PersonGenderId: number;
    Address: string;
    Ocupation: string;
    IsActive: boolean;
    Nationality: string;
    Location: string;
    IdCardFront: string;
    IdCardBack: string;

    constructor() {
        this.Id = GUID.newGuid();
        this.RelationshipId = 1;
        this.FirstName = 'tutor';
        this.LastName = 'tutorrr';
        this.DocumentNumber = '';
        this.CUIL = '';
        this.HighestEducationLevel = '';
        this.Email = '';
        this.PhoneNumber = '';
        this.MobilePhoneNumber = '';
        this.AnotherContactPhone = '';
        this.Birthdate = '2010/05/05';
        this.Photo = '';
        this.IdentificationTypeId = -1;
        this.PersonGenderId = 1;
        this.Address = '';
        this.Ocupation = '';
        this.Nationality = '';
        this.IdCardFront = '';
        this.IdCardBack = '';
        this.Location = '';
        this.IsActive = true;
    }
}



// WEBPACK FOOTER //
// ./src/app/main/models/tutors/dto/tutorDto.ts